module.exports = __webpack_public_path__ + "img/harvard-icon.a305a4a6.png";